import React from "react";

function BaseSectionItem({ header, renderImage, children, ...props }) {
  return (
    <div className={"main-item-wrapper wai-item"} {...props}>
      <div className="header display-row v-center">
        <b>{header}</b>
        {renderImage && renderImage()}
      </div>
      {children}
    </div>
  );
}

export default BaseSectionItem;
